import {
  Action,
  ActionType,
  IGetConsultationListResponse,
} from "models/consultation/list";
import createReducer from "../createReducer";

export interface ConsultationListReducerType {
  loading: boolean;
  error?: string;
  consultationListResponse?: IGetConsultationListResponse;
}

const defaultState: ConsultationListReducerType = {
  loading: false,
  error: undefined,
  consultationListResponse: undefined,
};

export const getConsultationListReducer =
  createReducer<ConsultationListReducerType>(defaultState, {
    [ActionType.GET_CONSULTATION_LIST](state: ConsultationListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_CONSULTATION_LIST_ERROR](
      state: ConsultationListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_CONSULTATION_LIST_SUCCESS](
      state: ConsultationListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        consultationListResponse: action.payload,
      };
    },
  });
